import React from 'react'
import {MapZoomLevelContext} from "../MapZoomLevelContextProvider";

export const useMapZoomLevelContext = () => React.useContext(MapZoomLevelContext)